import React from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { FiArrowRight, FiX } from 'react-icons/fi';
import {
    overlayVariants,
    modalVariants,
    getPhaseConfig,
    SurefireEagle,
    AnimatedProgressTrack,
    RepairAnimation,
    SurefireTitle,
    SurefirePhase1Card,
} from './surefireFeedback';

const SurefireSuccessPopup = ({ isOpen, message, progress, onConfirm, onDismiss, onShowSolution }) => {
    const reduced = useReducedMotion();
    if (!isOpen) return null;

    const config = getPhaseConfig(progress, message);
    const isPhase1 = config.type === 'phase1';

    return ReactDOM.createPortal(
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[9990] flex items-center justify-center px-4">
                    <motion.div
                        variants={overlayVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="absolute inset-0 backdrop-blur-sm bg-black/70"
                        onClick={onDismiss ?? onConfirm}
                    />

                    <motion.div
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="relative z-[9991] bg-white w-full max-w-sm rounded-2xl p-6 shadow-[0_8px_30px_-5px_rgba(35,56,85,0.15)] border border-gray-100 text-center overflow-hidden"
                    >
                        <button
                            onClick={onDismiss ?? onConfirm}
                            className="absolute top-3 right-3 p-2 text-gray-300 hover:text-gray-500 transition-colors rounded-full hover:bg-gray-50 z-10"
                        >
                            <FiX size={20} />
                        </button>

                        <SurefireEagle type={config.type} reduced={reduced} />

                        {config.type === 'repetition' && <RepairAnimation reduced={reduced} />}

                        {config.type !== 'repetition' && (
                            <AnimatedProgressTrack progress={progress || 3} phaseType={config.type} reduced={reduced} />
                        )}

                        <SurefireTitle config={config} reduced={reduced} />

                        {isPhase1 && <SurefirePhase1Card reduced={reduced} />}

                        <motion.button
                            initial={reduced ? false : { opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.7 }}
                            onClick={onConfirm}
                            className="w-full group flex items-center justify-center gap-2 py-3.5 rounded-xl font-bold font-apotek tracking-wider uppercase transition-all active:scale-[0.98] shadow-lg relative z-10 bg-[#233855] text-white hover:bg-[#1a2b42] shadow-[#233855]/20"
                        >
                            <span>wróć do listy pewniaków</span>
                            <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
                        </motion.button>

                        {onShowSolution && (
                            <motion.button
                                initial={reduced ? false : { opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 1.0 }}
                                onClick={onShowSolution}
                                className="mt-3 w-full text-xs text-gray-400 hover:text-gray-600 transition-colors py-1"
                            >
                                Najpierw sprawdź rozwiązanie →
                            </motion.button>
                        )}
                    </motion.div>
                </div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default SurefireSuccessPopup;
